import { JsonObject } from "json2typescript";
import { PortfolioDistibutionDataInterface } from "../interfaces/porfolio-distribution-data.interface";
/* PortfolioanalysisPositions*/
@JsonObject("PortfolioDistribution")
export class PortfolioDistribution implements PortfolioDistibutionDataInterface {
    BankCode?: string;
    Code?: string;
    Name?: string;
    Value?: number;
    Weight?: number;
    ColorHex?: string
    ColorCMYK?: string
    ColorRGB?: string

    constructor(obj?: any) {
        Object.assign(this, obj);
    }
}
